import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { getCategoriesRequest } from '../../redux/actions/getCategories';
import { sortDataBasedOnType } from '../../utility/jsonUtils';

import GenersGridContainer from '../../components/GenersOld/GenersGridContainer';

function ListContents(props) {

  const [originalGenersData, setOriginalGenersData] = useState(sortDataBasedOnType(props?.cat_data));

  useEffect(() => {
    if (!props?.cat_data && !props?.cat_loading) {
      props?.getGeners();
    }
  }, [])

  useEffect(() => {
    if (props?.cat_data && !props?.cat_loading) {
      setOriginalGenersData(sortDataBasedOnType(props?.cat_data));
    }

    if (props?.cat_error) {
      console.error("Error fetching categories:", props?.cat_error);
    }
  }, [props?.cat_data, props?.cat_loading, props?.cat_error]);


  return (
    <div style={styles.container}>
      <GenersGridContainer originalGenersData={originalGenersData} {...props} />
    </div>
  );
}

// Simple inline styles
const styles = {
  container: {
    padding: '40px',
    textAlign: 'center',
  },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => {
  return {
    cat_loading: state?.categories?.cat_loading,
    cat_error: state?.categories?.cat_error,
    cat_data: state?.categories?.cat_data,
  }
};

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = { getGeners: getCategoriesRequest };

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(ListContents);
